module.exports = __webpack_public_path__ + "img/neckline enclosed binding width.06fe4643.png";